import styled from 'styled-components';

import { CommonAction, recipesCommonAction, styledMedia, styledReset, styledTypography } from '@pkg/primitives';

import { tokens } from './SweepSlider.tokens';

export const StyledSweepSlider = styled.div`
    ${styledReset.borderBox};
    display: flex;
    align-items: center;
    gap: ${tokens.gap}px;
    padding: 0 ${tokens.padding.x}px;
    height: ${tokens.height}px;
    border-radius: 999px;
    border: 2px solid rgb(255, 255, 255, 0.1);
`;

export const SweepAction = styled(CommonAction)`
    ${recipesCommonAction.primary};
    flex: 0 0 auto;
    gap: ${tokens.action.gap}px;
    padding: 0 ${tokens.action.gap}px;
    min-width: ${tokens.action.minWidth}px;
    height: ${tokens.action.height}px;

    &:disabled {
        opacity: 0.8;
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.action.iconSize}px;
    height: ${tokens.action.iconSize}px;
`;

export const SweepValue = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.action.valueSize}px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
`;
